/**
 * PC 時 .l-container に Mac 風オーバーレイスクロールバーを付与
 * スクロール中のみ表示・幅は 0（レイアウトに影響しない）
 * サムは body に fixed で配置し、コンテナのスクロールと連動させる
 */

const PC_MEDIA = window.matchMedia('(min-width: 768px)');
const VISIBLE_DURATION_MS = 800;
const THUMB_WIDTH = 6;

let hideThumbTimer = null;
let container = null;
let thumb = null;
let onScroll = null;
let onResize = null;

function updateThumb() {
	if (!container || !thumb) return;
	const rect = container.getBoundingClientRect();
	const { scrollTop, scrollHeight, clientHeight } = container;
	const scrollable = scrollHeight > clientHeight;
	if (!scrollable) {
		thumb.style.opacity = '0';
		return;
	}
	const trackH = rect.height;
	const thumbH = Math.max(20, (clientHeight / scrollHeight) * clientHeight);
	const maxScroll = scrollHeight - clientHeight;
	const topOffset = maxScroll <= 0 ? 0 : (scrollTop / maxScroll) * (trackH - thumbH);
	thumb.style.left = `${rect.left + rect.width - THUMB_WIDTH}px`;
	thumb.style.top = `${rect.top + topOffset}px`;
	thumb.style.height = `${thumbH}px`;
	thumb.style.width = `${THUMB_WIDTH}px`;
}

function showThumb() {
	if (!thumb) return;
	thumb.classList.add('is-visible');
	if (hideThumbTimer) clearTimeout(hideThumbTimer);
	hideThumbTimer = setTimeout(() => {
		thumb.classList.remove('is-visible');
		hideThumbTimer = null;
	}, VISIBLE_DURATION_MS);
}

function init() {
	if (!PC_MEDIA.matches) return;
	const el = document.querySelector('.l-container');
	if (!el) return;
	container = el;

	thumb = document.createElement('div');
	thumb.setAttribute('aria-hidden', 'true');
	thumb.className = 'l-container__scroll-thumb';
	document.body.appendChild(thumb);

	updateThumb();

	onScroll = () => {
		updateThumb();
		showThumb();
	};
	onResize = () => updateThumb();

	container.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onResize);
}

function destroy() {
	if (container && onScroll) container.removeEventListener('scroll', onScroll);
	if (onResize) window.removeEventListener('resize', onResize);
	if (thumb?.parentNode) thumb.remove();
	container = null;
	thumb = null;
	onScroll = null;
	onResize = null;
	if (hideThumbTimer) {
		clearTimeout(hideThumbTimer);
		hideThumbTimer = null;
	}
}

export function initOverlayScrollbar() {
	init();
	PC_MEDIA.addEventListener('change', (e) => {
		if (e.matches) init();
		else destroy();
	});
}
